import { Service } from "typedi";
import { IApplePayPaymentDataCallBacks } from "../../../models/IApplePayPaymentDataCallbacks";
import { ApplePayCouponCodeResolver } from "./ApplePayCouponCodeResolver";
import { RequestJwtUpdateHandler } from "../../../../../application/core/services/st-codec/RequestJwtUpdateHandler";
import { IApplePaySession } from "../../models/IApplePaySession";

@Service()
export class ApplePayCouponCodeAction {
  constructor(private jwtRequestHandler: RequestJwtUpdateHandler) {}

  public execute(
    session: IApplePaySession,
    data: ApplePayJS.ApplePayCouponCodeChangedEvent,
    callbacks: IApplePayPaymentDataCallBacks,
  ): void {
    const resolver = new ApplePayCouponCodeResolver(
      session,
      this.jwtRequestHandler,
    );
    try {
      callbacks.onCouponCodeChanged?.(data, resolver);
    } catch (error) {
      // Suppress merchant callback errors to prevent SDK crashes
    }
  }
}
